import { CheckIcon } from '@phosphor-icons/react';
import { serviceIcon } from '@/components/serviceIcon';
import type { PublicService } from '@/lib/api/schemas';
import { formatInStudio, formatPrice } from '@/lib/format';

/**
 * What is already chosen, shown on top of the next booking steps: the service (with
 * its marker and price) and, once picked, the visit time with an accent tick.
 */
export function BookingSummary({
  service,
  currency,
  startsAt,
  timezone,
  onChange,
  changeLabel = 'Изменить',
}: {
  service: PublicService;
  currency: string;
  startsAt?: string | null;
  timezone: string;
  onChange?: () => void;
  changeLabel?: string;
}) {
  const Marker = serviceIcon(service);
  return (
    <div className="ui-summary" aria-label="Выбрано">
      <span className={`ui-icon-tile${startsAt ? ' ui-badge-icon--accent' : ''}`} style={{ width: 40, height: 40 }}>
        {startsAt ? <CheckIcon size={20} weight="bold" aria-hidden /> : <Marker size={20} aria-hidden />}
      </span>
      <span className="ui-stack ui-grow" style={{ ['--ui-gap' as string]: '2px' }}>
        <span className="ui-title">{service.name}</span>
        <span className="ui-caption ui-num">
          {startsAt
            ? `${formatInStudio(startsAt, timezone, "d MMMM, EEEEEE 'в' HH:mm")} · ${formatPrice(service.priceMinor, currency, service.priceKind)}`
            : formatPrice(service.priceMinor, currency, service.priceKind)}
        </span>
      </span>
      {onChange ? (
        <button
          type="button"
          className="ui-btn ui-btn--ghost ui-btn--sm"
          onClick={onChange}
          style={{ minHeight: 34, padding: '0 10px' }}
        >
          {changeLabel}
        </button>
      ) : null}
    </div>
  );
}
